export const BUILDING_DIRECTORY_TABS = {
    BUILDING_INFO: { id: 10, name: 'buildingInfo' },
};
